import React, { Fragment } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';

function ActionPlanPage() {
  return (
    <Fragment>
      <Helmet>
        <title>Action Plan</title>
      </Helmet>
      <div className="about-detail about-detail--resources">
        <div className="row">
          <div className="text about-detail__text about-detail__text--narrow">
            <h1>
              Resources
            </h1>
            <h2 className="small-h2">
              Wastage Calculator
            </h2>
            <p>
              This calculator is provided to help you understand the amount of wastage that occurs from drugs that are drawn up and not used and to be part of your analysis following the observation. This calculator pertains to questions 27, 28, 29 and 39 in the Anesthesia Tracer.
            </p>
          </div>
          <div className="about-detail__button-wrapper">
            <ReactGA.OutboundLink
              to="/documents/wastage-calculator.xlsx"
              className="button button--large"
              eventLabel="Download Wastage Calculator"
              download
              target="_blank"
              rel="noreferrer noopener"
            >
              Download Wastage Calculator
            </ReactGA.OutboundLink>
          </div>
        </div>
        <div className="row">
          <div className="text about-detail__text about-detail__text--narrow">
            <h2 className="small-h2">
              Action Plan
            </h2>
            <p>
              Once you’ve completed an assessment and have identified opportunities for improvement, you may want to create an action plan. Having a plan on paper can help clarify goals, assign responsibilities, and improve accountability. Download the worksheet to get started.
            </p>
          </div>
          <div className="about-detail__button-wrapper">
            <ReactGA.OutboundLink
              to="/documents/RTAMedSafety_ActionPlanWorksheet.docx"
              className="button button--large"
              eventLabel="Download Action Plan"
              download
              target="_blank"
              rel="noreferrer noopener"
            >
              Download Action Plan
            </ReactGA.OutboundLink>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ActionPlanPage;



// WEBPACK FOOTER //
// ./src/components/pages/ActionPlanPage.js